import { render, staticRenderFns } from "./purchase-orders-list.vue?vue&type=template&id=89f1cfd4&scoped=true&"
import script from "./purchase-orders-list.vue?vue&type=script&lang=js&"
export * from "./purchase-orders-list.vue?vue&type=script&lang=js&"
import style0 from "./purchase-orders-list.vue?vue&type=style&index=0&id=89f1cfd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f1cfd4",
  null
  
)

export default component.exports